/** Display currencies for shop browsing. Checkout remains in RWF. */
export const BASE_CURRENCY = 'RWF'

export const CURRENCIES = [
  { code: 'RWF', label: 'Rwandan Franc', symbol: 'RWF', locale: 'en-RW' },
  { code: 'USD', label: 'US Dollar', symbol: '$', locale: 'en-US' },
  { code: 'EUR', label: 'Euro', symbol: '€', locale: 'en-EU' },
  { code: 'GBP', label: 'British Pound', symbol: '£', locale: 'en-GB' },
  { code: 'KES', label: 'Kenyan Shilling', symbol: 'KSh', locale: 'en-KE' },
  { code: 'UGX', label: 'Ugandan Shilling', symbol: 'USh', locale: 'en-UG' },
]

/** Approximate fallback rates: 1 RWF → foreign (updated periodically if API fails) */
export const FALLBACK_RATES_FROM_RWF = {
  RWF: 1,
  USD: 0.00072,
  EUR: 0.00066,
  GBP: 0.00056,
  KES: 0.093,
  UGX: 2.65,
}

export const CURRENCY_STORAGE_KEY = 'fabritech_display_currency'
